import { hasSecondary } from 'layout/utils.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { filterSecondaryConfig } from 'page/layout-areas.js';
import * as React from 'react';
import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { IRepoState } from 'redux-state/rootReducer.js';
import { SecondaryLayout } from './secondary-layout.js';

interface ISecondarySectionMainProps {
  data: ILayoutConfig;
  displayPromo?: boolean;
}

const SecondarySectionMainEntry = ({ data, displayPromo = true }: ISecondarySectionMainProps) => {
  const { secondary, last } = data;

  const columnLayout = useContext(ColumnLayoutContext);
  const filteredConfig = useMemo(
    () => filterSecondaryConfig(secondary.slots, columnLayout),
    [secondary.slots, columnLayout],
  );
  const showPromo = displayPromo && last?.modules?.[0]?.showImage;
  const showSecondary = useMemo(() => hasSecondary(filteredConfig), [filteredConfig]);

  if (showSecondary) {
    return (
      <section className="App-secondary">
        <div className="Container Container--secondary">
          <SecondaryLayout showPromo={showPromo} />
        </div>
      </section>
    );
  }

  return null;
};

const _SecondarySectionMain = React.memo(SecondarySectionMainEntry);

export const SecondarySectionMain = ({ displayPromo }: Pick<ISecondarySectionMainProps, 'displayPromo'>) => {
  const data = useSelector((state: IRepoState) => state.LAYOUT.screen.layout);

  return <_SecondarySectionMain displayPromo={displayPromo} data={data} />;
};
